import { getStore } from "../store/store";
import { logUsage } from "owa-analytics";
import type { CommandingViewMode } from "owa-outlook-service-option-store/lib/store/schema/options/CommandingOptions";
import { mutatorAction } from "satcheljs";
import { getModuleContextMailboxInfo } from "owa-module-context-mailboxinfo";

export const onViewModeChangedInternalMutator: (viewMode: CommandingViewMode) => void = mutatorAction("onViewModeChangedInternal", (viewMode: CommandingViewMode): void => {
    logUsage("ViewModeChanged", getModuleContextMailboxInfo(), {
        from: getStore().viewMode,
        to: viewMode,
    });
    
    getStore().viewMode = viewMode;
});
